// Do not update. This file is auto-generated. To update, edit the equivalent JS file
// in common/constants and run `make generate-constants` in the root directory.

export const GEOJSON_EXTENSION = '.geojson';
export const TIF_EXTENSION = '.tif';
export const PNG_EXTENSION = '.png';
export const JPG_EXTENSION = '.jpg';
export const INT_NODATA_VALUE = 0;
export const FLOAT_NODATA_VALUE = -9999;
export const FC_WAITING_FOR_PROCESSING_STATUS = 'waiting-for-processing';
export const FC_WAITING_FOR_UPLOAD_STATUS = 'waiting-for-upload';
export const FC_WAITING_FOR_UPDATE_PROCESSING_STATUS = 'waiting-for-update-processing';
export const FC_PROCESSING_COMPLETE_STATUS = 'complete';
export const FC_FAILED_UPLOAD_STATUS = 'failed';
export const FEATURE_WAITING_FOR_PROCESSING_STATUS = 'waiting-for-processing';
export const FEATURE_PROCESSING_COMPLETE_STATUS = 'complete';
export const FEATURE_DATA_HYDRO_GENERATION_QUANTILES_DATE = '1900-01-01T00:00:00Z';
export const FEATURE_DATA_TIMESTAMP_START_DATE = '1970-01-01T00:00:00Z';
export const FILTER_FIELD_KEY = 'field';
export const FILTER_OPERATION_KEY = 'op';
export const FILTER_VALUE_KEY = 'val';
export const FILTER_TYPE_KEY = 'type';
export const FILTER_OPERATION_EQ = 'eq';
export const FILTER_OPERATION_NOT_EQ = 'not_eq';
export const FILTER_OPERATION_GT = 'gt';
export const FILTER_OPERATION_LT = 'lt';
export const FLOWLINES_FEATURE_COLLECTION_ID = 118;
export const HR_FLOWLINES_FEATURE_COLLECTION_ID = 377;
export const NID_DAMS_FEATURE_COLLECTION_ID = 53;
export const USGS_GAUGES_FEATURE_COLLECTION_ID = 2271;
export const USACE_GAUGES_FEATURE_COLLECTION_ID = 2917;
export const USACE_DRAINAGE_FEATURE_COLLECTION_ID = 2925;
export const DB_PRIVATE_GAUGE_FEATURE_COLLECTION_ID = 2551;
export const RFC_FORECASTS_FEATURE_COLLECTION_ID = 2533;
export const CNRFC_FORECASTS_FEATURE_COLLECTION_ID = 11377;
export const COMPOUND_RFC_FEATURE_COLLECTION_ID = 11784;
export const CO_DWR_GAUGES_FEATURE_COLLECTION_ID = 2932;
export const CO_DWR_DRAINAGE_FEATURE_COLLECTION_ID = 2934;
export const REGRID_FEATURE_COLLECTION_ID = 4153;
export const INDIGENOUS_TERRITORIES_FEATURE_COLLECTION_ID = 7031;
export const MICROSOFT_BUILDING_FOOTPRINTS_FEATURE_COLLECTION_ID = 3308;
export const TRANSMISSION_LINE_FEATURE_COLLECTION_ID = 7882;
export const MINES_FEATURE_COLLECTION_ID = 8017;
export const EPA_SUPERFUND_SITES_FEATURE_COLLECTION_ID = 9931;
export const OVERLAY_MAX_ZOOM_LEVEL = 11;
export const FEATURE_NAME = 'name';
export const MULTIFEATURE_PART_NAME = 'multiFeaturePartName';
export const NOTE_TYPE_USER = 'user';
export const NOTE_TYPE_SYSTEM_NEW_IMAGERY_AVAILABLE = 'system-new-imagery-available';
export const NOTE_TYPE_SYSTEM_NEW_IMAGERY_PROCESSED = 'system-new-imagery-processed';
export const NOTE_TYPE_ALERT = 'alert';
export const CUSTOM_ALERT_TYPE_THRESHOLD = 'threshold';
export const CUSTOM_ALERT_TYPE_CATEGORY = 'category';
export type CUSTOM_ALERT_TYPES_TYPE = 'threshold' | 'category';
export const CUSTOM_ALERT_TYPES: CUSTOM_ALERT_TYPES_TYPE[] = ['threshold', 'category'];
export const THRESHOLD_DIRECTION_ABOVE = 'above';
export const THRESHOLD_DIRECTION_BELOW = 'below';
export const NOTIFICATION_TYPE_LENS_MONITOR_DATA = 'monitor-data';
export const NOTIFICATION_TYPE_LENS_NOTE = 'note';
export const NOTIFICATION_TYPE_LENS_ALERT = 'alert';
export const NOTIFICATION_TYPE_LENS_IMAGERY_DONE_PROCESSING = 'imagery-done-processing';
export const NOTIFICATION_TYPE_LENS_NEW_IMAGERY_AVAILABLE = 'new-imagery-available';
export const NOTIFICATION_TYPE_LENS_PORTFOLIO_READY = 'portfolio-ready';
export const NOTIFICATION_TYPE_LENS_USER_SIGN_UP = 'user-signup';
export const NOTIFICATION_TYPE_LENS_ACCESS_RENEWAL = 'access-renewal';
export const NOTIFICATION_TYPE_LENS_COG_DOWNLOAD_READY = 'cog-download-ready';
export const NOTIFICATION_TYPE_HF_NEW_SHORT_TERM_FORECAST = 'new-short-term-forecast';
export const NOTIFICATION_TYPE_HF_FORECAST_THRESHOLD_START = 'forecast-threshold';
export const NOTIFICATION_TYPE_HF_FORECAST_THRESHOLD_END = 'forecast-threshold-end';
export const HYDROFORECAST_ALERT_TYPE_THRESHOLD = 'threshold';
export const HYDROFORECAST_ALERT_TYPE_LONG_TERM_AVERAGE_COMPARISON = 'long-term-average-comparison';
export const HYDROFORECAST_ALERT_TYPE_NEW_FORECAST = 'new-forecast';
export const HYDROFORECAST_ALERT_TYPE_UPCOMING_EVENT = 'upcoming-event';
export const NOTIFICATION_DELIVERY_METHOD_EMAIL = 'email';
export const NOTIFICATION_DELIVERY_METHOD_IN_APP = 'in-app';
export const NOTIFICATION_PRIORITY_DIGEST = 'digest';
export const NOTIFICATION_PRIORITY_IMMEDIATE = 'immediate';
export const NOTIFICATION_FREQUENCY_UNSUBSCRIBED = 'unsubscribed';
export const NOTIFICATION_SCOPE_ALL = 'all';
export const NOTIFICATION_SCOPE_MINE = 'mine';
export const NOTIFICATION_SCOPE_NONE = 'none';
export const PROJECT_PRODUCT_MONITORING = 'monitoring';
export type PROJECT_PRODUCTS_TYPE = 'monitoring';
export const PROJECT_PRODUCTS: PROJECT_PRODUCTS_TYPE[] = ['monitoring'];
export const PRODUCT_GEO_FEATURE = 'geofeature';
export const PRODUCT_META = 'meta';
export const PRODUCT_USER_POINT = 'user-point';
export const PRODUCT_USER_POLYGON = 'user-polygon';
export const PRODUCT_USER_LINE = 'user-line';
export const PRODUCT_SYSTEM_POINT = 'system-point';
export const PRODUCT_SYSTEM_POLYGON = 'system-polygon';
export const PRODUCT_SYSTEM_LINE = 'system-line';
export const PRODUCT_VARIANT_BIRD_RETURNS_COMPLIANCE = 'birdreturns-compliance';
export const PRODUCT_VARIANT_HYDRO_DROPS = 'hydro-drops';
export const PRODUCT_VARIANT_USGS = 'usgs';
export const PRODUCT_VARIANT_CA_DWR = 'ca-dwr';
export const PRODUCT_VARIANT_GLOS = 'glos';
export const PRODUCT_VARIANT_FEATURE = 'feature';
export const PRODUCT_LENS = 'lens';
export const PRODUCT_LENS_EXPERIMENTAL = 'lens-experimental';
export const PRODUCT_LENS_NO_SPOT = 'lens-no-spot';
export const PRODUCT_LENS_COMMERCIAL_FREE = 'lens-commercial-free';
export const PRODUCT_LENS_LANDSAT = 'lens-landsat';
export const PRODUCT_LENS_CARBON = 'lens-carbon';
export const PRODUCT_LENS_CARBON_SPACE_INTELLIGENCE = 'lens-carbon-space-intelligence';
export const PRODUCT_REGRID = 'regrid';
export const PRODUCT_HYDROFORECAST = 'HydroForecast';
export const VIEW_TYPE_AGGREGATE = 'aggregate';
export const VIEW_TYPE_BLOCKS = 'blocks';
export const VIEW_TYPE_MAP = 'map';
export const VIEW_TYPE_TABLE = 'table';
export const VIEW_TYPE_LAYERS = 'layers';
export const VIEW_TYPE_LENS = 'lens';
export const VIEW_TYPE_OVERLAY_METADATA = 'overlay_metadata';
export const VIEW_AGGREGATE_NUMERICAL = 'numerical';
export const VIEW_AGGREGATE_PIE_CHART = 'pieChart';
export const FEATURE_PROPERTY_UNKNOWN = 'Unknown';
export const FEATURE_PROPERTY_UNDETERMINED = 'Undetermined';
export const SMART_COLUMN_AREA = '_smart_area';
export type SCHEMA_GEO_TYPES_TYPE =
  | 'POINT'
  | 'LINE'
  | 'POLYGON'
  | 'ANY'
  | 'MULTIPOLYGON'
  | 'LINESTRING';
export const SCHEMA_GEO_TYPES: SCHEMA_GEO_TYPES_TYPE[] = [
  'POINT',
  'LINE',
  'POLYGON',
  'ANY',
  'MULTIPOLYGON',
  'LINESTRING',
];
export const SCHEMA_VIEWS_FEATURE_TABLE = 'feature-table';
export const SYSTEM_USER_ID = 'system@upstream.tech';
export const SYSTEM_ORGANIZATION_ID = 'system@upstream.tech';
export const DEMO_ORGANIZATION_ID = 'demo';
export const INTERNAL_ORGANIZATION_ID = '-KQ66NhS23Am_QKkk7CR';
export const PLANET_LABS_PBC_ORGANIZATION_ID = '1078146a-7950-4a53-b847-acc15ec458a4';
export const SUPERCRITICAL_ORGANIZATION_ID = '6fffd844-f454-4e24-a07b-e7b4c00d98ef';
export const TNC_CA_PROPERTY_MONITORING_ORG_ID = 'f52d71db-ce56-43ab-a241-1dbeae199dbf';
export const USER_SETTINGS_ZOOM_BEHAVIOR = 'zoomBehavior';
export const COMPLIANCE_START_DATE_KEY = 'complianceStartDate';
export const COMPLIANCE_END_DATE_KEY = 'complianceEndDate';
export const USER_ROLE_KEY = 'role';
export const USER_ROLE_OWNER = 'owner';
export const USER_ROLE_REGULAR = 'regular';
export const USER_ROLE_READONLY = 'readonly';
export const USER_ROLE_PUBLIC_API_READONLY = 'publicapi_readonly';
export const USER_ROLE_PUBLIC_API_READWRITE = 'publicapi_readwrite';
export const USER_ROLE_INVALID_REQUEST_CODE = 405;
export const SCOPE_PUBLIC_API_READONLY = 'readonly';
export const SCOPE_PUBLIC_API_READWRITE = 'readwrite';
export const SCOPE_PUBLIC_API_STREAMIMAGERY = 'streamimagery';
export const SCOPE_PUBLIC_API_EMAIL_OBSERVATIONS = 'emailobservations';
export type PUBLIC_API_SCOPES_TYPE = 'readonly' | 'readwrite' | 'streamimagery';
export const PUBLIC_API_SCOPES: PUBLIC_API_SCOPES_TYPE[] = [
  'readonly',
  'readwrite',
  'streamimagery',
];
export const ORIGINAL_POLYGON_PROPERTY = 'originalPolygon';
export const META_ORGANIZATION_ID = 'meta@upstream.tech';
export type HTTP_WRITE_METHODS_TYPE = 'POST' | 'PUT' | 'PATCH' | 'DELETE';
export const HTTP_WRITE_METHODS: HTTP_WRITE_METHODS_TYPE[] = ['POST', 'PUT', 'PATCH', 'DELETE'];
export const UNIT_AREA_ACRE = 'areaAcre';
export const UNIT_AREA_KM2 = 'areaKM2';
export const UNIT_AREA_F2 = 'areaF2';
export const UNIT_AREA_M2 = 'areaM2';
export const UNIT_AREA_HECTARE = 'areaHectare';
export const UNIT_CURRENCY_USD = 'currencyUSD';
export const UNIT_ENERGY_KWATTH = 'kwatth';
export const UNIT_ENERGY_KWATTHY = 'kwatthy';
export const UNIT_FLOW_CFS = 'flowcfs';
export const UNIT_FLOW_CMS = 'flowcms';
export const UNIT_LENGTH_FT = 'lengthft';
export const UNIT_LENGTH_IN = 'lengthin';
export const UNIT_LENGTH_KM = 'lengthkm';
export const UNIT_LENGTH_M = 'lengthm';
export const UNIT_PERCENT = 'percent';
export const UNIT_PERCENT_UNIT = 'percentunit';
export const UNIT_POWER_KWATT = 'kwatt';
export const UNIT_SPEED_MPH = 'mi/h';
export const UNIT_SPEED_MS = 'm/s';
export const UNIT_TEMPERATURE_CELSIUS = 'celsius';
export const UNIT_TEMPERATURE_FAHRENHEIT = 'fahrenheit';
export const UNIT_TEMPERATURE_KELVIN = 'kelvin';
export const UNIT_VOLUME_ACREFTY = 'acre-ft/yr';
export const UNIT_VOLUME_ACREFT_ACRE_YEAR = 'acre-ft/acre/yr';
export const UNIT_VOLUME_INDAY = 'in/day';
export const UNIT_VOLUME_KGY = 'kg/yr';
export const UNIT_VOLUME_LBSY = 'lbs/yr';
export const UNIT_VOLUME_LBS_ACRE_YEAR = 'lbs/acre/yr';
export const UNIT_VOLUME_M3 = 'm3';
export const UNIT_VOLUME_MM6HR = 'mm/6hr';
export const UNIT_VOLUME_TONY = 'tons/yr';
export const UNIT_VOLUME_TON_ACRE_YEAR = 'tons/acre/yr';
export type UNITS_TYPE =
  | 'areaAcre'
  | 'areaKM2'
  | 'areaM2'
  | 'areaHectare'
  | 'currencyUSD'
  | 'kwatth'
  | 'kwatthy'
  | 'flowcfs'
  | 'flowcms'
  | 'lengthft'
  | 'lengthin'
  | 'lengthkm'
  | 'lengthm'
  | 'percent'
  | 'percentunit'
  | 'kwatt'
  | 'mi/h'
  | 'm/s'
  | 'celsius'
  | 'fahrenheit'
  | 'kelvin'
  | 'acre-ft/yr'
  | 'acre-ft/acre/yr'
  | 'in/day'
  | 'kg/yr'
  | 'lbs/yr'
  | 'lbs/acre/yr'
  | 'm3'
  | 'mm/6hr'
  | 'tons/yr'
  | 'tons/acre/yr';
export const UNITS: UNITS_TYPE[] = [
  'areaAcre',
  'areaKM2',
  'areaM2',
  'areaHectare',
  'currencyUSD',
  'kwatth',
  'kwatthy',
  'flowcfs',
  'flowcms',
  'lengthft',
  'lengthin',
  'lengthkm',
  'lengthm',
  'percent',
  'percentunit',
  'kwatt',
  'mi/h',
  'm/s',
  'celsius',
  'fahrenheit',
  'kelvin',
  'acre-ft/yr',
  'acre-ft/acre/yr',
  'in/day',
  'kg/yr',
  'lbs/yr',
  'lbs/acre/yr',
  'm3',
  'mm/6hr',
  'tons/yr',
  'tons/acre/yr',
];
export const SYSTEM_PROPERTIES_KEY = '__system';
export const SYSTEM_PROPERTY_PAID_IMAGERY_KEY = 'paidImagery';
export const APP_PROPERTIES_KEY = '__app';
export const APP_PROPERTY_ASSIGNEE_EMAIL = 'assigneeEmail';
export const APP_PROPERTY_REPORTING_DUE_DATE = 'reportingDueDate';
export const APP_PROPERTY_TAG_IDS = 'tagIds';
export const APP_PROPERTY_WMTS_URL = 'wmtsUrl';
export const APP_PROPERTY_STREAMIMAGERY_API_KEY = 'streamImageryApiKey';
export const RDM_PROPERTIES_KEY = '__rdm';
export const RDM_PROPERTIES_COMPLIANCE_KEY = 'compliance';
export const ALERT_VEGETATION_DROP_ENROLLMENT_KEY = 'processVegetationDrop';
export const ALERT_VEGETATION_DROP_USER_ID = 'vegetation_drop@upstream.tech';
export const ALERT_OWNERSHIP_CHANGE_ENROLLMENT_KEY = 'processOwnershipChange';
export const ALERT_OWNERSHIP_CHANGE_USER_ID = 'ownership_change@upstream.tech';
export const USER_UPDATED_PROPERTIES_KEY = '__user_updated_properties';
export const PURCHASE_FUNDS_USAGE = 'usage';
export const PURCHASE_FUNDS_VOID = 'void';
export const PURCHASE_FUNDS_REPLACED = 'replaced';
export const PURCHASE_EVENT_PURCHASE = 'purchase';
export const PURCHASE_EVENT_VOID = 'void';
export const PURCHASE_EVENT_SPEND_CREDIT = 'spendCredit';
export const CONTRACT_TYPE_ACRE_UNIT = 'acreUnit';
export const CONTRACT_TYPE_DOLLAR_UNIT = 'dollarUnit';
export const SOURCE_DETAILS_BY_ID = {
  L8: {
    name: 'Landsat 8',
    resolution: 30,
    revisit: 16,
    operator: 'NASA/USGS',
    hq: true,
    copyright_template: 'USGS/NASA Landsat',
    shareable: true,
  },
  S2: {
    name: 'Sentinel-2A/B',
    resolution: 10,
    revisit: 5,
    operator: 'ESA',
    hq: true,
    copyright_template: 'Copernicus Sentinel data <YEAR>',
    shareable: true,
  },
  S1: {
    name: 'Sentinel-1',
    resolution: 20,
    revisit: 6,
    operator: 'ESA',
    hq: false,
    copyright_template: 'Copernicus Sentinel data <YEAR>',
    shareable: true,
  },
  AIRBUS: {
    name: '',
    resolution: 0.5,
    revisit: 365,
    operator: 'Airbus',
    hq: true,
    copyright_template: '© CNES <YEAR>, Distribution AIRBUS DS',
    shareable: true,
    paid: true,
  },
  'AIRBUS-PLEIADES': {
    name: 'Pléiades',
    resolution: 0.5,
    revisit: 365,
    operator: 'Airbus',
    hq: true,
    copyright_template: '© CNES <YEAR>, Distribution AIRBUS DS',
    shareable: true,
    paid: true,
    not_allowed_countries: ['CN', 'HK', 'SA'],
  },
  'AIRBUS-PLEIADES-ARCHIVE': {
    name: 'Pléiades, Extended Archive',
    resolution: 0.5,
    revisit: 365,
    operator: 'Airbus',
    hq: true,
    copyright_template: '© CNES <YEAR>, Distribution AIRBUS DS',
    shareable: true,
    paid: true,
    not_allowed_countries: ['CN', 'HK', 'SA'],
    minimum_order_acres: 100,
  },
  'AIRBUS-PNEO': {
    name: 'Pléiades Neo',
    resolution: 0.3,
    revisit: 365,
    operator: 'Airbus',
    hq: true,
    copyright_template: 'COPYRIGHT AIRBUS DS, France, all rights reserved',
    shareable: true,
    paid: true,
    not_allowed_countries: ['CN', 'HK', 'JP', 'SA', 'TW'],
  },
  'AIRBUS-PNEO-ARCHIVE': {
    name: 'Pléiades Neo, Extended Archive',
    resolution: 0.3,
    revisit: 365,
    operator: 'Airbus',
    hq: true,
    copyright_template: 'COPYRIGHT AIRBUS DS, France, all rights reserved',
    shareable: true,
    paid: true,
    not_allowed_countries: ['CN', 'HK', 'JP', 'SA', 'TW'],
    minimum_order_acres: 300,
  },
  'AIRBUS-SPOT': {
    name: 'SPOT',
    resolution: 1.5,
    revisit: 365,
    operator: 'Airbus',
    hq: true,
    copyright_template: '© AIRBUS DS <YEAR>',
    shareable: true,
    paid: true,
    not_allowed_countries: [
      'AZ',
      'CA',
      'CN',
      'EE',
      'GE',
      'HK',
      'IR',
      'KG',
      'LV',
      'LT',
      'MD',
      'PK',
      'SA',
      'TJ',
      'TM',
      'UZ',
    ],
  },
  'AIRBUS-SPOT-ARCHIVE': {
    name: 'SPOT, Extended Archive',
    resolution: 1.5,
    revisit: 365,
    operator: 'Airbus',
    hq: true,
    copyright_template: '© AIRBUS DS <YEAR>',
    shareable: true,
    paid: true,
    not_allowed_countries: [
      'AZ',
      'CA',
      'CN',
      'EE',
      'GE',
      'HK',
      'IR',
      'KG',
      'LV',
      'LT',
      'MD',
      'PK',
      'SA',
      'TJ',
      'TM',
      'UZ',
    ],
    minimum_order_acres: 100,
  },
  'DIGITAL-GLOBE': {
    name: 'WorldView',
    resolution: 0.3,
    revisit: 365,
    operator: 'Maxar',
    hq: true,
    copyright_template: 'Includes copyrighted material of Maxar Technologies Inc. <YEAR>',
    shareable: false,
    paid: true,
  },
  'DIGITAL-GLOBE-30': {
    name: 'WorldView',
    resolution: 0.3,
    revisit: 365,
    operator: 'Maxar',
    hq: true,
    copyright_template: 'Includes copyrighted material of Maxar Technologies Inc. <YEAR>',
    shareable: false,
    paid: true,
  },
  'DIGITAL-GLOBE-50': {
    name: 'WorldView',
    resolution: 0.5,
    revisit: 365,
    operator: 'Maxar',
    hq: true,
    copyright_template: 'Includes copyrighted material of Maxar Technologies Inc. <YEAR>',
    shareable: false,
    paid: true,
  },
  NAIP: {
    name: 'NAIP',
    resolution: 1,
    revisit: 1095,
    operator: 'USDA',
    copyright_template: 'U.S. Department of Agriculture, Farm Service Agency',
    shareable: true,
  },
  NLCD: {
    name: 'NLCD',
    resolution: 30,
    revisit: 1095,
    operator: 'USGS',
    copyright_template: 'USGS',
    shareable: true,
  },
  'ESA-WORLDCOVER': {
    name: 'WorldCover',
    resolution: 10,
    revisit: 365,
    operator: 'ESA',
    copyright_template:
      '© ESA WorldCover project 2020 / Contains modified Copernicus Sentinel data (2020) processed by ESA WorldCover consortium',
    shareable: true,
  },
  'PLANET-SKYSAT-COLLECT': {
    name: 'SkySat',
    resolution: 0.5,
    revisit: 365,
    operator: 'Planet',
    hq: true,
    copyright_template: '© <YEAR> Planet Labs PBC All rights reserved.',
    shareable: true,
    paid: true,
    not_allowed_countries: ['BY', 'CN', 'HK', 'KH', 'MM', 'NI', 'RU', 'VE'],
  },
  'PLANET-BASEMAP': {
    name: 'Basemap',
    resolution: 4,
    revisit: 30,
    operator: 'Planet',
    hq: true,
    copyright_template: '© <YEAR> Planet Labs PBC All rights reserved.',
    premium: true,
    billing_intervals: ['month', 'year'],
    allowed_countries: [
      'AI',
      'AG',
      'AR',
      'AW',
      'BS',
      'BB',
      'BZ',
      'BO',
      'BQ',
      'BV',
      'BR',
      'KY',
      'CL',
      'CO',
      'CR',
      'CU',
      'CW',
      'DM',
      'DO',
      'EC',
      'SV',
      'FK',
      'GF',
      'GD',
      'GP',
      'GT',
      'GY',
      'HT',
      'HN',
      'JM',
      'MQ',
      'MX',
      'MS',
      'NI',
      'PA',
      'PY',
      'PE',
      'PR',
      'BL',
      'KN',
      'LC',
      'MF',
      'VC',
      'SX',
      'GS',
      'SR',
      'TT',
      'TC',
      'UY',
      'VE',
      'VG',
      'VI',
      'BM',
      'CA',
      'GL',
      'PM',
      'US',
    ],
    shareable: false,
  },
  'PLANET-FOREST-CARBON-30': {
    name: 'Forest Carbon Diligence',
    resolution: 30,
    revisit: 1,
    operator: 'Planet',
    hq: false,
    copyright_template: '<YEAR> Planet Labs PBC',
    shareable: true,
    paid: true,
  },
  'PLANET-FOREST-CARBON-3': {
    name: 'Forest Carbon Monitoring',
    resolution: 3,
    revisit: 1,
    operator: 'Planet',
    hq: false,
    copyright_template: '<YEAR> Planet Labs PBC',
    shareable: true,
    paid: true,
  },
  NEARMAP: {
    operator: 'Nearmap',
    name: '',
    resolution: 0.5,
    hq: true,
    copyright_template: '© Nearmap <YEAR>',
    shareable: false,
    paid: true,
  },
  'NEARMAP-15': {
    operator: 'Nearmap',
    name: '',
    resolution: 0.15,
    hq: true,
    copyright_template: '© Nearmap <YEAR>',
    shareable: false,
    paid: true,
    maximum_order_acres: 1000,
  },
  'NEARMAP-50': {
    operator: 'Nearmap',
    name: '',
    resolution: 0.5,
    hq: true,
    copyright_template: '© Nearmap <YEAR>',
    shareable: false,
    paid: true,
  },
  SNODAS: {
    operator: 'National Snow and Ice Data Center',
    name: 'Snow Data Assimilation System',
    resolution: 1000,
    revisit: 1,
    hq: false,
    copyright_template: 'National Operational Hydrologic Remote Sensing Center',
    shareable: true,
  },
  SALO: {
    name: 'Forest Carbon',
    revisit: 365,
    operator: 'Planet',
    copyright_template: '© <YEAR> Planet Labs PBC All rights reserved.',
    resolution: 10,
    shareable: false,
  },
  'SPACE-INTELLIGENCE': {
    name: '',
    resolution: 25,
    revisit: 365,
    operator: 'Space Intelligence',
    copyright_template: '© Space Intelligence. All rights reserved.',
    shareable: false,
  },
  'CHLORIS-BIOMASS': {
    name: 'Biomass',
    resolution: 4600,
    revisit: 365,
    operator: 'Chloris Geospatial',
    copyright_template:
      'Chloris Geospatial. Creative Commons Attribution Non Commercial Share Alike 4.0 International.',
    shareable: true,
  },
  CHLORIS: {
    name: '',
    resolution: 30,
    revisit: 365,
    operator: 'Chloris Geospatial',
    copyright_template: 'Chloris Data ©️ <YEAR> Chloris Geospatial Inc.',
    shareable: true,
    licenseLink:
      'https://cdn.prod.website-files.com/6197d5aab3f545ea3c1c5438/671b9d5827701b056d11fa69_Chloris%20Geospatial%20AGB%20EULA.pdf',
  },
  'CHLORIS-30': {
    name: '',
    resolution: 30,
    revisit: 365,
    operator: 'Chloris Geospatial',
    copyright_template: 'Chloris Data ©️ <YEAR> Chloris Geospatial Inc.',
    shareable: true,
    paid: true,
    licenseLink:
      'https://cdn.prod.website-files.com/6197d5aab3f545ea3c1c5438/671b9d5827701b056d11fa69_Chloris%20Geospatial%20AGB%20EULA.pdf',
    minimum_order_acres: 247,
  },
  'CHLORIS-10': {
    name: '',
    resolution: 10,
    revisit: 365,
    operator: 'Chloris Geospatial',
    copyright_template: 'Chloris Data ©️ <YEAR> Chloris Geospatial Inc.',
    shareable: true,
    paid: true,
    licenseLink:
      'https://cdn.prod.website-files.com/6197d5aab3f545ea3c1c5438/671b9d5827701b056d11fa69_Chloris%20Geospatial%20AGB%20EULA.pdf',
    minimum_order_acres: 25,
  },
  MOBI: {
    name: '',
    resolution: 990,
    revisit: 365,
    operator: 'NatureServe',
    copyright_template: 'NatureServe',
    shareable: true,
  },
  'IMPACT-OBSERVATORY-BIODIVERSITY': {
    operator: 'Impact Observatory and Vizzuality',
    name: '',
    resolution: 100,
    revisit: 365,
    copyright_template:
      'Impact Observatory and Vizzuality. Creative Commons Attribution 4.0 International.',
    shareable: true,
  },
  'IMPACT-OBSERVATORY-LANDCOVER': {
    operator: 'Impact Observatory',
    name: '',
    resolution: 10,
    revisit: 365,
    copyright_template: 'Impact Observatory. Creative Commons Attribution 4.0 International.',
    shareable: true,
  },
  'IMPACT-OBSERVATORY-HIGH-RES-LANDCOVER': {
    operator: 'Impact Observatory',
    name: '',
    resolution: 10,
    revisit: 365,
    copyright_template: 'Impact Observatory. Creative Commons Attribution 4.0 International.',
    shareable: true,
  },
  'GLOBAL-FOREST-CHANGE': {
    operator: 'University of Maryland GLAD Lab',
    name: '',
    resolution: 30,
    revisit: 365,
    copyright_template:
      'Hansen/UMD/Google/USGS/NASA. Creative Commons Attribution 4.0 International.',
    shareable: true,
  },
  'MAPBIOMAS-BRAZIL-LANDCOVER': {
    operator: 'MapBiomas Project',
    name: '',
    resolution: 30,
    revisit: 365,
    copyright_template:
      'MapBiomas Project - Collection 8 of the Annual Series of Land Cover and Use Maps of Brazil.',
    shareable: true,
  },
  'MAPBIOMAS-CHACO-LANDCOVER': {
    operator: 'MapBiomas Project',
    name: '',
    resolution: 30,
    revisit: 365,
    copyright_template:
      'MapBiomas Project - Collection 4 of the Annual Series of Land Cover and Use Maps of the Chago Region.',
    shareable: true,
  },
  'SBTN-WRINLC': {
    operator: 'World Resources Institute',
    name: '',
    resolution: 30,
    revisit: 365,
    copyright_template: 'World Resources Institute',
    shareable: true,
  },
  'METAWRI-CANOPY-HEIGHT': {
    operator: 'Meta and World Resources Institute',
    name: '',
    resolution: 1,
    revisit: 365,
    copyright_template: 'Meta. Creative Commons Attribution 4.0 International.',
    shareable: true,
  },
  'TMF-ANNUAL-CHANGE': {
    operator: 'European Commission JRC',
    name: '',
    resolution: 30,
    revisit: 365,
    copyright_template: 'EC JRC',
    shareable: true,
  },
  'PRISM-M': {
    operator: 'PRISM Climate Group',
    name: '',
    resolution: 4000,
    revisit: 30,
    copyright_template: 'PRISM Climate Group',
    shareable: false,
  },
  'WMTS-TRUECOLOR': {operator: '', name: '', copyright_template: '', shareable: true},
  'WMS-TRUECOLOR': {operator: '', name: '', copyright_template: '', shareable: true},
};
export type SCENE_PROPERTY_ADDITIONAL_FIELDS_TYPE =
  | 'vendor_name'
  | 'sensor_name'
  | 'copyright'
  | 'cloud_cover_percentage'
  | 'resolution';
export const SCENE_PROPERTY_ADDITIONAL_FIELDS: SCENE_PROPERTY_ADDITIONAL_FIELDS_TYPE[] = [
  'vendor_name',
  'sensor_name',
  'copyright',
  'cloud_cover_percentage',
  'resolution',
];
export const SCENE_PROPERTY_VENDOR_NAME = 'vendor_name';
export const SCENE_PROPERTY_SENSOR_NAME = 'sensor_name';
export const SCENE_PROPERTY_COPYRIGHT_TEXT = 'copyright';
export const SCENE_PROPERTY_CLOUD_COVER_PERCENTAGE = 'cloud_cover_percentage';
export const SCENE_PROPERTY_RESOLUTION = 'resolution';
export const SCENE_PROPERTY_MOSAIC_RANGE = 'mosaic_range';
export type IMAGERY_RESOLUTION_TYPES_TYPE = 'MEDIUM' | 'HIGH';
export const IMAGERY_RESOLUTION_TYPES: IMAGERY_RESOLUTION_TYPES_TYPE[] = ['MEDIUM', 'HIGH'];
export const MEDIUM_RESOLUTION_TYPE = 'MEDIUM';
export const HIGH_RESOLUTION_TYPE = 'HIGH';
export const OAUTH_SCOPE_READONLY = 'readonly';
export type OAUTH_SCOPES_TYPE = 'readonly';
export const OAUTH_SCOPES: OAUTH_SCOPES_TYPE[] = ['readonly'];
export const DISABLE_ORDERS_SOURCE_IDS = [];
export const ORG_PRODUCT_LENS = 'Lens';
export const ORG_PRODUCT_HYDROFORECAST = 'HydroForecast';
export type ORG_PRODUCTS_TYPE = 'Lens' | 'HydroForecast';
export const ORG_PRODUCTS: ORG_PRODUCTS_TYPE[] = ['Lens', 'HydroForecast'];
export const ORG_SETTING_DISPLAY_AREA_UNIT = 'display_area_unit';
export const ORG_SETTING_NOTE_SORT_ORDER = 'note_sort_order';
export const ORG_SETTING_NOTE_DATE_FILTER = 'note_date_filter';
export const ORG_SETTING_DEFAULT_PROCESSING_PRODUCT = 'default_processing_product';
export const ORG_SETTING_LOGO = 'logo';
export const ORG_SETTING_AUTHENTICATION_CONFIG = 'authentication_config';
export const ORG_SETTING_DEFAULT_BASEMAP = 'default_basemap';
export const ORG_SETTING_SHOW_SMART_SUMMARIES = 'show_smart_summaries';
export const ORG_SETTING_WMTS_ADDITIONAL_SOURCES = 'wmts_additional_sources';
export const ORG_SETTING_SEAT_LIMIT = 'seat_limit';
export const ORG_SETTING_FEATURE_TAGS = 'feature_tags';
export const ORG_SETTING_NOTE_TAGS = 'note_tags';
export type USER_MODIFIABLE_ORG_SETTINGS_TYPE =
  | 'default_basemap'
  | 'show_smart_summaries'
  | 'wmts_additional_sources'
  | 'display_area_unit'
  | 'note_sort_order'
  | 'note_date_filter'
  | 'logo'
  | 'feature_tags'
  | 'note_tags';
export const USER_MODIFIABLE_ORG_SETTINGS: USER_MODIFIABLE_ORG_SETTINGS_TYPE[] = [
  'default_basemap',
  'show_smart_summaries',
  'wmts_additional_sources',
  'display_area_unit',
  'note_sort_order',
  'note_date_filter',
  'logo',
  'feature_tags',
  'note_tags',
];
export type ORG_SETTING_KEYS_TYPE =
  | 'display_area_unit'
  | 'note_sort_order'
  | 'note_date_filter'
  | 'default_processing_product'
  | 'logo'
  | 'authentication_config'
  | 'default_basemap'
  | 'show_smart_summaries'
  | 'wmts_additional_sources'
  | 'seat_limit'
  | 'feature_tags'
  | 'note_tags';
export const ORG_SETTING_KEYS: ORG_SETTING_KEYS_TYPE[] = [
  'display_area_unit',
  'note_sort_order',
  'note_date_filter',
  'default_processing_product',
  'logo',
  'authentication_config',
  'default_basemap',
  'show_smart_summaries',
  'wmts_additional_sources',
  'seat_limit',
  'feature_tags',
  'note_tags',
];
export const ORG_SETTING_PREFIX_HF_FAVORITE_SITES = 'hf_favorite_sites__';
export type ORG_SETTING_KEY_PREFIXES_TYPE = 'hf_favorite_sites__';
export const ORG_SETTING_KEY_PREFIXES: ORG_SETTING_KEY_PREFIXES_TYPE[] = ['hf_favorite_sites__'];
export const SIGNUP_TOKEN_VALIDITY_DAYS = 14;
export const US_CONTIGUOUS_BBOX = {
  type: 'Polygon',
  coordinates: [
    [
      [-66.945392, 24.521208],
      [-66.945392, 49.382808],
      [-124.736342, 49.382808],
      [-124.736342, 24.521208],
      [-66.945392, 24.521208],
    ],
  ],
};
export const US_AK_BBOX = {
  type: 'Polygon',
  coordinates: [
    [
      [-187.538333, 51.219862],
      [-129.980058, 51.219862],
      [-129.980058, 71.352561],
      [-187.538333, 71.352561],
      [-187.538333, 51.219862],
    ],
  ],
};
export const US_HI_BBOX = {
  type: 'Polygon',
  coordinates: [
    [
      [-160.555771, 18.917466],
      [-154.809379, 18.917466],
      [-154.809379, 22.23317],
      [-160.555771, 22.23317],
      [-160.555771, 18.917466],
    ],
  ],
};
export const US_PR_BBOX = {
  type: 'Polygon',
  coordinates: [
    [
      [-67.954119, 17.884813],
      [-65.22111, 17.884813],
      [-65.22111, 18.515757],
      [-67.954119, 18.515757],
      [-67.954119, 17.884813],
    ],
  ],
};
export const BRAZIL_SHAPE = {
  type: 'Polygon',
  coordinates: [
    [
      [-66.73868763191244, 3.817727302365795],
      [-66.76492270794989, 3.8920935101043055],
      [-65.28075854617934, 6.206433354549793],
      [-60.85608179904895, 6.821899895754845],
      [-56.34706239461037, 4.433440259337895],
      [-53.22849792243042, 5.34847040816386],
      [-49.54341285586391, 5.125052862587175],
      [-49.1610224696129, 3.772118293490612],
      [-45.494097642314856, 0.8540762923100035],
      [-43.167764162704295, -0.253086241407905],
      [-39.84749187667955, -0.8522552236794818],
      [-37.357660673882265, -2.1657232486481],
      [-34.15792124794975, -4.282495836303781],
      [-33.03653022357906, -6.97749581185895],
      [-33.0929757997198, -8.637809217421603],
      [-34.2530476309725, -10.965928428458733],
      [-35.80024094566871, -12.864583596808126],
      [-36.9989310827132, -16.33539479425263],
      [-38.07786739482119, -20.2702666191586],
      [-42.608043657866865, -24.5381661881276],
      [-46.236395068296986, -26.37392450849916],
      [-46.46942276715549, -28.440815885322195],
      [-50.005247447210614, -32.99588814944223],
      [-54.4102572857727, -33.71551697388108],
      [-57.93766764241119, -31.608869439694164],
      [-57.85062177478954, -27.783620480378982],
      [-57.56205361384025, -27.266208197106657],
      [-57.78404495513337, -23.303990461102543],
      [-59.66079598586483, -20.91168223658777],
      [-61.74832762126287, -17.251210757064356],
      [-61.93144556744948, -16.809425519632185],
      [-65.23950069492332, -14.122295275327359],
      [-65.92893100332086, -13.596217034573508],
      [-72.33446033772208, -11.977998302285295],
      [-75.38561109034882, -8.978126422271606],
      [-75.81701380754065, -7.866079615572957],
      [-73.61959291201032, -3.4927494889299666],
      [-72.04473692551578, 0.16965109068903655],
      [-69.1406604253911, 3.390085970939774],
      [-66.73868763191244, 3.817727302365795],
    ],
  ],
};
export const CHACO_BBOX = {
  type: 'Polygon',
  coordinates: [
    [
      [-71.5734499, -14.5497432],
      [-71.5734499, -35.7004867],
      [-53.9118528, -35.7004867],
      [-53.9118528, -14.5497432],
      [-71.5734499, -14.5497432],
    ],
  ],
};
export const LENS_TIER_FOCUS = 'lens-focus';
export const LENS_TIER_PLUS = 'lens-plus';
export const LENS_TIER_ENTERPRISE = 'lens-enterprise';
export type LENS_TIERS_TYPE = 'lens-focus' | 'lens-plus' | 'lens-enterprise';
export const LENS_TIERS: LENS_TIERS_TYPE[] = ['lens-focus', 'lens-plus', 'lens-enterprise'];
export const LENS_TIER_SETTINGS = {
  'lens-focus': {name: 'Lens Lite', seatLimit: 3},
  'lens-plus': {name: 'Lens Standard', seatLimit: 10},
  'lens-enterprise': {name: 'Lens Enterprise', seatLimit: null},
};
export const LENS_ACCESS_SUBSCRIPTION_FOCUS = 'focus_annual';
export const LENS_ACCESS_SUBSCRIPTION_FOCUS_MONTHLY = 'focus_monthly';
export const LENS_ACCESS_SUBSCRIPTION_FOCUS_NGO = 'focus_ngo_annual';
export const LENS_ACCESS_SUBSCRIPTION_FOCUS_NGO_MONTHLY = 'focus_ngo_monthly';
export const LENS_ACCESS_SUBSCRIPTION_PLUS = 'plus_annual';
export const LENS_ACCESS_SUBSCRIPTION_PLUS_MONTHLY = 'plus_monthly';
export const LENS_ACCESS_SUBSCRIPTION_PLUS_NGO = 'plus_ngo_annual';
export const LENS_ACCESS_SUBSCRIPTION_PLUS_NGO_MONTHLY = 'plus_ngo_monthly';
export const LENS_ACCESS_SUBSCRIPTION_PLUS_ENTERPRISE_MEMBER = 'plus_enterprise_member';
export const LENS_ACCESS_SUBSCRIPTION_PLUS_DEMO = 'plus_demo';
export const LENS_ACCESS_SUBSCRIPTION_ENTERPRISE = 'enterprise';
export type LENS_ACCESS_SUBSCRIPTIONS_TYPE =
  | 'focus_annual'
  | 'focus_monthly'
  | 'focus_ngo_annual'
  | 'focus_ngo_monthly'
  | 'plus_annual'
  | 'plus_monthly'
  | 'plus_ngo_annual'
  | 'plus_ngo_monthly'
  | 'plus_enterprise_member'
  | 'plus_demo'
  | 'enterprise';
export const LENS_ACCESS_SUBSCRIPTIONS: LENS_ACCESS_SUBSCRIPTIONS_TYPE[] = [
  'focus_annual',
  'focus_monthly',
  'focus_ngo_annual',
  'focus_ngo_monthly',
  'plus_annual',
  'plus_monthly',
  'plus_ngo_annual',
  'plus_ngo_monthly',
  'plus_enterprise_member',
  'plus_demo',
  'enterprise',
];
export const LIVE_LENS_PUBLIC_IMAGERY_PRODUCT_ID = 'prod_R4xS7V6kloODmz';
export const TEST_LENS_PUBLIC_IMAGERY_PRODUCT_ID = 'prod_R4xjs3hvNg19Pd';
export const LENS_ADDON_STORAGE = 'storage';
export type LENS_ADDONS_TYPE = 'storage';
export const LENS_ADDONS: LENS_ADDONS_TYPE[] = ['storage'];
export const LENS_ACCESS_SUBSCRIPTION_SIGNUP_OPTIONS = {
  focus_annual: {name: 'Lens Lite'},
  focus_monthly: {name: 'Lens Lite'},
  plus_annual: {name: 'Lens Standard'},
  plus_monthly: {name: 'Lens Standard'},
};
export const LENS_BUNDLE_SIGNUP_OPTIONS = {
  planet_basemaps_monthly: {
    display: 'Planet Basemaps',
    allowed_countries: [
      'AI',
      'AG',
      'AR',
      'AW',
      'BS',
      'BB',
      'BZ',
      'BO',
      'BQ',
      'BV',
      'BR',
      'KY',
      'CL',
      'CO',
      'CR',
      'CU',
      'CW',
      'DM',
      'DO',
      'EC',
      'SV',
      'FK',
      'GF',
      'GD',
      'GP',
      'GT',
      'GY',
      'HT',
      'HN',
      'JM',
      'MQ',
      'MX',
      'MS',
      'NI',
      'PA',
      'PY',
      'PE',
      'PR',
      'BL',
      'KN',
      'LC',
      'MF',
      'VC',
      'SX',
      'GS',
      'SR',
      'TT',
      'TC',
      'UY',
      'VE',
      'VG',
      'VI',
      'BM',
      'CA',
      'GL',
      'PM',
      'US',
    ],
  },
  planet_basemaps_annual: {
    display: 'Planet Basemaps',
    allowed_countries: [
      'AI',
      'AG',
      'AR',
      'AW',
      'BS',
      'BB',
      'BZ',
      'BO',
      'BQ',
      'BV',
      'BR',
      'KY',
      'CL',
      'CO',
      'CR',
      'CU',
      'CW',
      'DM',
      'DO',
      'EC',
      'SV',
      'FK',
      'GF',
      'GD',
      'GP',
      'GT',
      'GY',
      'HT',
      'HN',
      'JM',
      'MQ',
      'MX',
      'MS',
      'NI',
      'PA',
      'PY',
      'PE',
      'PR',
      'BL',
      'KN',
      'LC',
      'MF',
      'VC',
      'SX',
      'GS',
      'SR',
      'TT',
      'TC',
      'UY',
      'VE',
      'VG',
      'VI',
      'BM',
      'CA',
      'GL',
      'PM',
      'US',
    ],
  },
};
export const LENS_FEATURE_IMAGE_COLLECTION_BOUNDS_SOURCE_ID_KEY = '_bounds_source_id';
export const LENS_WINDOW_GEOMETRY_SOURCE_ID_KEY_SUFFIX = 'window-geometry-bounds';
export const ESA_WORLDCOVER_VALUE_MAP = {
  '0': {color: '#000000', label: 'Unknown'},
  '10': {color: '#006400', label: 'Trees'},
  '20': {color: '#ffbb22', label: 'Shrubland'},
  '30': {color: '#ffff4c', label: 'Grassland'},
  '40': {color: '#f096ff', label: 'Cropland'},
  '50': {color: '#fa0000', label: 'Built-up'},
  '60': {color: '#b4b4b4', label: 'Barren / sparse vegetation'},
  '70': {color: '#f0f0f0', label: 'Snow and ice'},
  '80': {color: '#0064c8', label: 'Open water'},
  '90': {color: '#0096a0', label: 'Herbaceous wetland'},
  '95': {color: '#00cf75', label: 'Mangroves'},
  '100': {color: '#fae6a0', label: 'Moss and lichen'},
};
export const GLOBAL_FOREST_CHANGE_LOSSYEAR_VALUE_MAP = {
  '0': {color: '#E0E0E0', label: 'No Loss', order: 1},
  '1': {color: '#67001f', label: 'Forest Loss', order: 0},
};
export const TMF_ANNUAL_CHANGE_VALUE_MAP = {
  '1': {color: '#005A00', label: 'Undisturbed tropical moist forest'},
  '2': {color: '#649B23', label: 'Degraded tropical moist forest'},
  '3': {color: '#FF870F', label: 'Deforested land'},
  '4': {color: '#D2FA3C', label: 'Tropical moist forest regrowth'},
  '5': {color: '#008CBE', label: 'Permanent and seasonal water'},
  '6': {color: '#FFFFFF', label: 'Other land cover'},
};
export const NLCD_LANDCOVER_VALUE_MAP = {
  '0': {color: '#000000', label: 'Unknown'},
  '1': {color: '#5475A8', label: 'Open Water'},
  '2': {color: '#ffffff', label: 'Perennial Ice/Snow'},
  '3': {color: '#E8D1D1', label: 'Developed, Open Space'},
  '4': {color: '#E29E8C', label: 'Developed, Low Intensity'},
  '5': {color: '#ff0000', label: 'Developed, Medium Intensity'},
  '6': {color: '#B50000', label: 'Developed High Intensity'},
  '7': {color: '#D2CDC0', label: 'Barren Land (Rock/Sand/Clay)'},
  '8': {color: '#85C77E', label: 'Deciduous Forest'},
  '9': {color: '#38814E', label: 'Evergreen Forest'},
  '10': {color: '#D4E7B0', label: 'Mixed Forest'},
  '11': {color: '#AF963C', label: 'Dwarf Scrub'},
  '12': {color: '#DCCA8F', label: 'Shrub/Scrub'},
  '13': {color: '#FDE9AA', label: 'Grassland/Herbaceous'},
  '14': {color: '#D1D182', label: 'Sedge/Herbaceous'},
  '15': {color: '#A3CC51', label: 'Lichens'},
  '16': {color: '#82BA9E', label: 'Moss'},
  '17': {color: '#FBF65D', label: 'Pasture/Hay'},
  '18': {color: '#CA9146', label: 'Cultivated Crops'},
  '19': {color: '#C8E6F8', label: 'Woody Wetlands'},
  '20': {color: '#64B3D5', label: 'Emergent Herbaceous Wetlands'},
};
export const MAPBIOMAS_BRAZIL_LANDCOVER_VALUE_MAP = {
  '1': {color: '#32a65e', label: 'Forest'},
  '3': {color: '#1f8d49', label: 'Forest Formation'},
  '4': {color: '#7dc975', label: 'Savanna Formation'},
  '5': {color: '#04381d', label: 'Mangrove'},
  '6': {color: '#026975', label: 'Floodable Forest'},
  '9': {color: '#7a5900', label: 'Forest Plantation'},
  '10': {color: '#ad975a', label: 'Herbaceous and Shrubby Vegetation'},
  '11': {color: '#519799', label: 'Wetland'},
  '12': {color: '#d6bc74', label: 'Grassland'},
  '14': {color: '#FFFFB2', label: 'Farming'},
  '15': {color: '#edde8e', label: 'Pasture'},
  '18': {color: '#E974ED', label: 'Agriculture'},
  '19': {color: '#C27BA0', label: 'Temporary Crop'},
  '20': {color: '#db7093', label: 'Sugar cane'},
  '21': {color: '#ffefc3', label: 'Mosaic of Uses'},
  '22': {color: '#d4271e', label: 'Non vegetated area'},
  '23': {color: '#ffa07a', label: 'Beach'},
  '24': {color: '#d4271e', label: 'Urban Area'},
  '25': {color: '#db4d4f', label: 'Other non Vegetated Areas'},
  '26': {color: '#0000FF', label: 'Water'},
  '27': {color: '#ffffff', label: 'Not Observed'},
  '29': {color: '#ffaa5f', label: 'Rocky Outcrop'},
  '30': {color: '#9c0027', label: 'Mining'},
  '31': {color: '#091077', label: 'Aquaculture'},
  '32': {color: '#fc8114', label: 'Hypersaline Tidal Flat'},
  '33': {color: '#2532e4', label: 'River'},
  '35': {color: '#9065d0', label: 'Palm Oil'},
  '36': {color: '#d082de', label: 'Perennial Crop'},
  '39': {color: '#f5b3c8', label: 'Soybean'},
  '40': {color: '#c71585', label: 'Rice'},
  '41': {color: '#f54ca9', label: 'Other Temporary Crops'},
  '46': {color: '#d68fe2', label: 'Coffee'},
  '47': {color: '#9932cc', label: 'Citrus'},
  '48': {color: '#e6ccff', label: 'Other Perennial Crops'},
  '49': {color: '#02d659', label: 'Wooded Sandbank Vegetation'},
  '50': {color: '#ad5100', label: 'Herbaceous Sandbank Vegetation'},
  '62': {color: '#ff69b4', label: 'Cotton (beta)'},
};
export const MAPBIOMAS_CHACO_LANDCOVER_VALUE_MAP = {
  '1': {color: '#1f8d49', label: 'Natural wooded vegetation'},
  '3': {color: '#1f8d49', label: 'Closed woodland'},
  '4': {color: '#7dc975', label: 'Open woodland'},
  '6': {color: '#007785', label: 'Flooded woodland'},
  '9': {color: '#7a5900', label: 'Forest plantation'},
  '10': {color: '#d6bc74', label: 'Natural non-wooded vegetation'},
  '11': {color: '#519799', label: 'Flooded Grassland'},
  '12': {color: '#d6bc74', label: 'Grassland'},
  '14': {color: '#ffefc3', label: 'Agricultural and livestock areas'},
  '15': {color: '#edde8e', label: 'Pasture'},
  '18': {color: '#e974ed', label: 'Agriculture'},
  '19': {color: '#d5a6bd', label: 'Annual Crops'},
  '22': {color: '#d4271e', label: 'Non-vegetated area'},
  '23': {color: '#ffa07a', label: 'Beach, Dune and Sand Spot'},
  '24': {color: '#d4271e', label: 'Urban Area'},
  '25': {color: '#db4d4f', label: 'Other non Vegetated Areas'},
  '26': {color: '#2532e4', label: 'Water bodies'},
  '27': {color: '#ffffff', label: 'Not observed'},
  '36': {color: '#d082de', label: 'Shrub plantation'},
  '42': {color: '#a5b35b', label: 'Open Grassland'},
  '43': {color: '#c2d26b', label: 'Closed Grassland'},
  '44': {color: '#cbe286', label: 'Sparse Grassland'},
  '45': {color: '#807a40', label: 'Sparse woodland'},
  '57': {color: '#f99fff', label: 'Single crop'},
  '58': {color: '#d84690', label: 'Multiple crop'},
  '61': {color: '#f5d5d5', label: 'Salt Flat'},
};
export const SBTN_NATURAL_LANDS_CLASSIFICATION_VALUE_MAP = {
  '0': {color: '#D3D3D3', label: 'Non-Natural'},
  '1': {color: '#a8ddb5', label: 'Natural'},
  '2': {color: '#246E24', label: 'Forests'},
  '3': {color: '#B9B91E', label: 'Short Vegetation'},
  '4': {color: '#6BAED6', label: 'Water'},
  '5': {color: '#06A285', label: 'Mangroves'},
  '6': {color: '#FEFECC', label: 'Bare Ground'},
  '7': {color: '#ACD1E8', label: 'Snow'},
  '8': {color: '#589558', label: 'Wetland Forests'},
  '9': {color: '#093D09', label: 'Peat Forests'},
  '10': {color: '#DBDB7B', label: 'Wetland Short Vegetation'},
  '11': {color: '#99991A', label: 'Peat Short Vegetation'},
};
export const SPACE_INTELLIGENCE_HABITAT_VALUE_MAP = {
  '0': {color: '#000000', label: 'No data'},
  '1': {color: '#006200', label: 'Forest'},
  '2': {color: '#4f1209', label: 'Tree Farm'},
  '3': {color: '#e599c2', label: 'Vegetated Non-Forest'},
  '4': {color: '#499fd8', label: 'Water'},
  '5': {color: '#6d666b', label: 'Bare'},
  '6': {color: '#f9f62c', label: 'Agriculture & Pasture'},
  '7': {color: '#d47a2c', label: 'Plantation Tree Crops'},
  '8': {color: '#1f645c', label: 'Mangrove Forest'},
};
export const SPACE_INTELLIGENCE_HABITAT_URBAN_VALUE_MAP = {
  '0': {color: '#000000', label: 'No data'},
  '5': {color: '#1c1dff', label: 'Water'},
  '6': {color: '#747474', label: 'Bare/Paved/Developed'},
  '7': {color: '#e51f6e', label: 'Buildings'},
  '8': {color: '#007419', label: 'Wooded areas'},
  '9': {color: '#7bcd00', label: 'Non-wooded areas'},
  '10': {color: '#c4ac5d', label: 'Orchard'},
};
export const SPACE_INTELLIGENCE_HABITAT_10_CLASS_VALUE_MAP = {
  '0': {color: '#000000', label: 'No data'},
  '1': {color: '#00300f', label: 'Dense Forest'},
  '2': {color: '#017e3b', label: 'Open Forest'},
  '3': {color: '#00aa7a', label: 'Mangrove Forest'},
  '4': {color: '#bb45bc', label: 'Forest Plantation'},
  '5': {color: '#ffc1ff', label: 'Tree Crops'},
  '6': {color: '#61592b', label: 'Shrub'},
  '7': {color: '#fffc8d', label: 'Grassland / Pasture'},
  '8': {color: '#f28f32', label: 'Agriculture'},
  '9': {color: '#8b8471', label: 'Urban / Bare'},
  '10': {color: '#1d60b8', label: 'Water'},
};
export const IMPACT_OBSERVATORY_LANDCOVER_VALUE_MAP = {
  '0': {color: '#000000', label: 'No data'},
  '1': {color: '#419BDF', label: 'Water'},
  '2': {color: '#397D49', label: 'Trees'},
  '4': {color: '#7A87C6', label: 'Flooded Vegetation'},
  '5': {color: '#E49635', label: 'Crops'},
  '7': {color: '#C4281B', label: 'Built Area'},
  '8': {color: '#A59B8F', label: 'Bare Ground'},
  '9': {color: '#A8EBFF', label: 'Snow/Ice'},
  '10': {color: '#616161', label: 'Clouds'},
  '11': {color: '#E3E2C3', label: 'Rangeland'},
};
export const IMPACT_OBSERVATORY_HIGH_RES_LANDCOVER_VALUE_MAP = {
  '0': {color: '#000000', label: 'No Data'},
  '1': {color: '#ffffff', label: 'Water Channel Extent'},
  '2': {color: '#bfdaf5', label: 'Variable Water'},
  '3': {color: '#25579d', label: 'Persistent Water'},
  '4': {color: '#005e24', label: 'Dense Trees'},
  '5': {color: '#aecca1', label: 'Sparse Trees'},
  '6': {color: '#a9a76a', label: 'Dense Rangeland'},
  '7': {color: '#f1e9b9', label: 'Sparse Rangeland'},
  '8': {color: '#7a87c6', label: 'Flooded Vegetation'},
  '9': {color: '#e49635', label: 'Crops'},
  '10': {color: '#67000d', label: 'High Density Built'},
  '11': {color: '#c44d45', label: 'Low Density Built'},
  '12': {color: '#a59b8f', label: 'Bare Ground'},
  '13': {color: '#a8ebff', label: 'Snow/Ice'},
  '14': {color: '#616161', label: 'Clouds'},
};
export const CHLORIS_FOREST_VALUE_MAP = {
  '0': {color: '#c1ada8', label: 'Non-Forest'},
  '1': {color: '#227c27', label: 'Forest'},
};
export const DASHBOARD_ERRORS = {NO_STATISTICS_FOUND: 'No statistics found'};
export const UPLOAD_PROBLEMS = '__UPSTREAM_PROBLEMS';
export const UPLOAD_ERROR_CONSTANTS = {
  FILE_TOO_LARGE: {
    text: 'File size is too large',
    supportUrl: 'https://support.upstream.tech/article/147-preparing-geospatial-data-for-lens#size',
    label: 'File too large',
  },
  UNSUPPORTED_FILE_TYPE: {
    text: 'must provide file as a zipped shapefile (.zip), .kml, .kmz or .geojson',
    supportUrl: 'https://support.upstream.tech/article/147-preparing-geospatial-data-for-lens#file',
    label: 'Unsupported file type',
  },
  NO_POLYGONAL_GEOMETRY: {
    text: 'No polygonal geometry found (lines and points are not supported).',
    supportUrl:
      'https://support.upstream.tech/article/147-preparing-geospatial-data-for-lens#polygonal',
    label: 'No polygonal geometry',
  },
  DUPLICATE_FEATURES: {
    text: 'Duplicate features found',
    supportUrl:
      'https://support.upstream.tech/article/147-preparing-geospatial-data-for-lens#duplicate',
    label: 'Duplicate features',
  },
  TOO_MANY_FEATURES: {
    text: 'Too many features provided',
    supportUrl: 'https://support.upstream.tech/article/147-preparing-geospatial-data-for-lens#many',
    label: 'Too many features',
  },
  TOO_MANY_COORDINATES: {
    text: 'Feature has too many coordinates',
    supportUrl:
      'https://support.upstream.tech/article/147-preparing-geospatial-data-for-lens#coordinates',
    label: 'Feature too many coordinates',
  },
  INVALID_FEATURE_GEOMETRY: {
    text: 'Feature geometry is not valid',
    supportUrl:
      'https://support.upstream.tech/article/147-preparing-geospatial-data-for-lens#invalid',
    label: 'Invalid feature geometry',
  },
  TOO_SMALL_AREA: {
    text: 'Feature area is too small',
    supportUrl:
      'https://support.upstream.tech/article/147-preparing-geospatial-data-for-lens#small',
    label: 'Feature too small',
  },
  TOO_LARGE_AREA: {
    text: 'Feature area is too large',
    supportUrl:
      'https://support.upstream.tech/article/147-preparing-geospatial-data-for-lens#large',
    label: 'Feature too large',
  },
  TOO_SPREAD_OUT: {
    text: 'Feature area is too spread out',
    supportUrl:
      'https://support.upstream.tech/article/147-preparing-geospatial-data-for-lens#spread',
    label: 'Feature too spread out',
  },
  NO_MATCHED_FEATURES: {
    text: 'No matched features were found in this file',
    supportUrl: 'https://support.upstream.tech/article/74-updating-properties',
    label: 'No updates found',
  },
};
export const LENS_APP_PROD_URL = 'https://app.upstream.tech';
export const LENS_APP_STAGING_URL_PREFIX = 'https://monitron-dev--';
export const LENS_APP_DEV_URL = 'http://localhost:9999';
export const LOGIN_APP_PROD_URL = 'https://login.upstream.tech';
export const LOGIN_APP_STAGING_URL_PREFIX = 'https://login-app-web-upstream--';
export const LOGIN_APP_DEV_URL = 'http://localhost:3001';
export const HYDROFORECAST_APP_PROD_URL = 'https://dashboard.hydroforecast.com';
export const HYDROFORECAST_APP_STAGING_URL_PREFIX = 'https://hydroforecast-web--';
export const HYDROFORECAST_APP_DEV_URL = 'http://localhost:3000';
export const SERIES_PROCESSOR_IDS_TO_INIT_TIME_OFFSET_MINUTES = {
  'ecmwf-hres': 450,
  gefs: 390,
  gfs: 315,
  hrrr: 90,
};
